import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useCallback, useMemo, useState } from "react";
export var useAmazonHoverTriangle = function() {
    var _useState = _sliced_to_array(useState(null), 2), points = _useState[0], setPoints = _useState[1];
    var area = useMemo(function() {
        if (!points) {
            return null;
        }
        var _points = _sliced_to_array(points, 3), a = _points[0], b = _points[1], c = _points[2];
        return calculateArea(a, b, c);
    }, [
        points
    ]);
    var setTriangle = useCallback(function(a, b, c) {
        setPoints([
            a,
            b,
            c
        ]);
    }, []);
    var isPointInsideTriangle = useCallback(function(point) {
        if (!points || !area) {
            return null;
        }
        var _points = _sliced_to_array(points, 3), a = _points[0], b = _points[1], c = _points[2];
        var AreaA = calculateArea(point, a, b);
        var AreaB = calculateArea(point, b, c);
        var AreaC = calculateArea(point, a, c);
        return area >= AreaA + AreaB + AreaC;
    }, [
        area,
        points
    ]);
    return {
        points: points,
        setTriangle: setTriangle,
        isPointInsideTriangle: isPointInsideTriangle
    };
};
var calculateArea = function(a, b, c) {
    var area = (a.x * (b.y - c.y) + b.x * (c.y - a.y) + c.x * (a.y - b.y)) / 2;
    return area < 0 ? -1 * area : area;
};
